<template>
  <div class="examPage" style="padding: 0 12px 60px;">
    <!-- 判卷结果态:右上角显示考生总分 -->
    <div v-if="showResult" class="examScore">得分：{{ totalScore }}</div>
    <p style="text-align: center;font-size: 16px;font-weight: bold;">{{ configs.name }}</p>
    <p style="padding:4px 0 15px;text-align: center;">及格线({{ configs.pass_line }}分)</p>
    <el-form v-if="configs && configs.questions && configs.questions.length" :model="configs" ref="ruleForm"
      label-width="180px" class="demo-ruleForm">
      <template v-for="(item, index) in configs.questions">
        <el-form-item :key="index" v-if="item.type == '单选'" style="width: 100%;"
          :label="`${index + 1}. ${item.name}(${item.score}分)`"
          :prop="`questions[${index}].value`"><!--:rules="isRadioRequired(item.required)"-->
          <el-radio-group v-model="item.value" :disabled="showResult">
            <el-radio v-for="(val, ids) in item.options" :key="ids" :label="val.value">{{ val.value }}. {{
              val.label }}</el-radio>
          </el-radio-group>
          <div v-if="item.pic" style="display: flex;flex-wrap: wrap;">
            <div v-for="(img, index) in item.pic.split(',')" :key="index" style="width: 100px;margin: 4px;">
              <el-image :src="img" :preview-src-list="item.pic.split(',')">
              </el-image>
              <div style="text-align: center;font-size: 13px;color: #555;line-height: 1;">图{{ index + 1 }}</div>
            </div>
          </div>
          <div v-if="showResult" class="answerResult">
            考生答案：<span :class="item.right ? 'right' : 'wrong'">{{ answerText(item.value) }}</span>
            <span class="rightAnswer">正确答案：{{ answerText(item.answers) }}</span>
            <span class="answerFlag" :class="item.right ? 'right' : 'wrong'">{{ item.right ? '✔ 正确' : '✘ 错误'
              }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="item.type == '多选'" :label="`${index + 1}. ${item.name}(${item.score}分)`"
          style="width: 100%;">
          <el-checkbox-group v-model="item.value" :disabled="showResult">
            <el-checkbox v-for="(val, ids) in item.options" :key="ids" :label="val.value">{{ val.value }}.
              {{ val.label }}</el-checkbox>
          </el-checkbox-group>
          <div v-if="item.pic" style="display: flex;flex-wrap: wrap;">
            <div v-for="(img, index) in item.pic.split(',')" :key="index" style="width: 100px;margin: 4px;">
              <el-image :src="img" :preview-src-list="item.pic.split(',')">
              </el-image>
              <div style="text-align: center;font-size: 13px;color: #555;line-height: 1;">图{{ index + 1 }}</div>
            </div>
          </div>
          <div v-if="showResult" class="answerResult">
            考生答案：<span :class="item.right ? 'right' : 'wrong'">{{ answerText(item.value) }}</span>
            <span class="rightAnswer">正确答案：{{ answerText(item.answers) }}</span>
            <span class="answerFlag" :class="item.right ? 'right' : 'wrong'">{{ item.right ? '✔ 正确' : '✘ 错误'
              }}</span>
          </div>
        </el-form-item>
        <!-- <el-form-item v-if="item.type == '简答题'" :label="`${index + 1}. ${item.name}`"
          :prop="`questions[${index}].value`"
          style="width: 100%;">
          <el-input type="textarea" v-model="item.value" :rows="5" placeholder="请输入"></el-input>
        </el-form-item> -->
      </template>
      <el-form-item v-if="!isPreview" style="margin-top:20px; width: 100%; text-align: center;">
        <el-button type="primary" @click="submitFormByFun('ruleForm', handSubmit)">提交</el-button>
      </el-form-item>
    </el-form>
    <el-empty v-else description="暂无数据"></el-empty>
  </div>
</template>
<script>

export default {
  props: {
    formData: { type: Object, default: () => ({ name: '', questions: [], pass_line: 60 }) },
    isPreview: { type: Boolean, default: true },
    // 判卷结果态:回显考生答案、标出对错、右上角显示总分(默认关闭,不影响试卷预览等原有用法)
    showResult: { type: Boolean, default: false },
    totalScore: { type: [Number, String], default: '' },
    // fun: { type: Function, default: () => {} },
  },
  data() {
    return {
      configs: {
        name: '',
        pass_line: '',
        questions: [],
      },
    };
  },
  // 数据随时可通过 watch 消费,不依赖 mounted 时机(el-dialog 内容组件挂载/销毁与弹窗可见存在时序差)
  watch: {
    formData: {
      handler(val) {
        this.initConfigs(val || {});
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 把试卷数据(formData)解析进 configs:对结构做防御,避免因字段缺失/格式差异整页空白
    initConfigs(formData) {
      formData = formData || {};
      this.configs.id = formData.id
      this.configs.course_id = formData.course_id
      this.configs.name = formData.name || ''
      this.configs.pass_line = formData.pass_line
      const list = Array.isArray(formData.questions) ? formData.questions : []
      this.configs.questions = list.map(item => {
        // 判卷结果态回显考生答案(value),否则清空
        let value = this.showResult ? item.value : (item.type == "多选" ? [] : '')
        if (value === undefined || value === null) value = item.type == "多选" ? [] : ''
        return {
          type: item.type,
          name: item.name,
          value: value,
          right: this.isAnswerRight(item),
          answers: item.answers,
          // 分值优先取 pivot.score(paper detail),其次平铺 score
          score: (item.pivot && item.pivot.score !== undefined) ? item.pivot.score : item.score,
          // options 兼容 JSON 字符串与已解析数组
          options: Array.isArray(item.options) ? item.options : (item.options ? this.getArrByJSON(item.options) : []),
          pic: item.pic,
        }
      })
      console.log('initConfigs', this.configs && this.configs.questions && this.configs.questions.length)

    },
    // 考生答案与正确答案比对:answers 是 JSON 字符串;value 单选是字符串、多选是数组
    isAnswerRight(item) {
      const right = this.getArrByJSON(item.answers)
      const mine = Array.isArray(item.value) ? item.value.slice() : (item.value ? [item.value] : [])
      if (!right.length || !mine.length) return false
      return right.map(String).sort().join(',') === mine.map(String).sort().join(',')
    },
    // 答案 → 显示文本(如 "A、B")
    answerText(val) {
      if (val === undefined || val === null || val === '') return '未作答'
      let arr = Array.isArray(val) ? val : this.getArrByJSON(val)
      if (!arr || !arr.length) arr = [val]
      return arr.join('、')
    },
    isRadioRequired(required) {
      return required ? [{ required: true, message: '请选择', trigger: 'change' }] : []
    },
    isInputRequired(required) {
      return required ? [{ required: true, message: '请输入', trigger: 'blur' }] : []
    },
    getArrByJSON(json) {
      try {
        const arr = JSON.parse(json)
        if (Array.isArray(arr)) {
          return arr
        } else {
          return []
        }
      } catch (e) {
        return []
      }
    },
    handSubmit() {
      let score = 0;
      if (this.configs.questions && this.configs.questions.length) {
        this.configs.questions.forEach(item => {
          if (item.answers && item.value) {
            if (item.type == '多选') {
              if (JSON.stringify(item.value.sort()) == item.answers) {
                score += item.score
              }
            }
            if (item.type == '单选') {
              if (JSON.stringify([item.value]) == item.answers) {
                score += item.score
              }
            }
          }
        })
      }
      this.configs.score = score
      this.$confirm('是否现在交卷?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('submitExam', this.configs)
      })
    }
    ,
    submitFormByFun(formName, $fun) {
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          $fun()
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
/deep/.el-form-item__label {
  width: 100% !important;
  text-align: left;
}
/deep/.el-checkbox__input.is-disabled+span.el-checkbox__label{
  color: inherit;
}
/deep/.el-radio__input.is-disabled+span.el-radio__label{
  color: inherit;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}

/deep/.el-radio {
  padding: 4px;
}

/deep/.el-image {
  display: block;
  margin-bottom: 8px;
}

/* 判卷结果态 */
.examPage {
  position: relative;
}

.examScore {
  position: absolute;
  top: 0;
  right: 0;
  padding: 2px 12px;
  border-radius: 4px;
  font-size: 20px;
  font-weight: bold;
  color: #e33b3f;
}

.answerResult {
  margin-top: 6px;
  font-size: 13px;
  color: #606266;

  .rightAnswer {
    margin-left: 16px;
  }

  .answerFlag {
    margin-left: 16px;
    font-weight: bold;
  }

  .right {
    color: #1a9c5b;
  }

  .wrong {
    color: #e33b3f;
  }
}
</style>
